import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon';
import type { OverridableComponent } from '@mui/types';
import { ReactComponent as TikTokSvg } from 'assets/icons/socialmedia/tiktok.svg';

const TikTokIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon ref={ref} component={TikTokSvg} inheritViewBox {...props} />
)) as OverridableComponent<SvgIconTypeMap<Record<string, never>, 'svg'>>;

(TikTokIcon as any).muiName = 'SvgIcon';

export default TikTokIcon;
